export const VISITOR_PRIMARY_NAV_ITEMS = [
  { to: "/", label: "Home" },
  { to: "/map", label: "Map" },
  { to: "/events", label: "Events" },
  { to: "/business-network", label: "Business Network", featured: true },
  { to: "/housing-development", label: "Housing & Development" },
  { to: "/directory", label: "Directory" },
  { to: "/community", label: "Community" },
  { to: "/community-voice", label: "Community Voice" },
  { to: "/phoenix-hub", label: "Phoenix Hub" },
];

export const VISITOR_SECONDARY_NAV_ITEMS = [
  { to: "/about", label: "About", icon: "info" },
  { to: "/get-involved", label: "Get involved", icon: "helpingHand" },
  { to: "/food-bank", label: "Food Bank", icon: "heartHandshake" },
  { to: "/profile", label: "Profile", icon: "user" },
  { to: "/insights", label: "Insights", icon: "insights" },
];

export const AUTHENTICATED_SECONDARY_NAV_ITEMS = [
  { to: "/admin", label: "Admin Dashboard" },
];

export function visitorNavigationPaths() {
  return [...VISITOR_PRIMARY_NAV_ITEMS, ...VISITOR_SECONDARY_NAV_ITEMS].map((item) => item.to);
}
